export const TYPE_FLAGS_RU = [
  { key: 'fz44', label: '44-ФЗ' },
  { key: 'fz223', label: '223-ФЗ' },
  { key: 'pp615', label: '615 ПП РФ' },
  { key: 'comm', label: 'Коммерческие РФ' },
  { key: 'plan', label: 'План-График' },
  { key: 'sale', label: 'Торги по продаже' },
]

export const TYPE_FLAGS_KZ = [
  { key: 'kzgov', label: 'Госзакупки Казахстан' },
  { key: 'kzcomm', label: 'Коммерческие Казахстан' },
]
